export const configHeaderVariant = [
  { name: "kodeVariant", label: "Kode Varian", options: { sort: false } },
  { name: "variant", label: "Nama Varian", options: { sort: false } },
];

export const configIndentReport = [
  { name: "kodeWarna", label: "Kode Warna", options: { sort: false } },
  { name: "namaWarna", label: "Nama Warna", options: { sort: false } },
  { name: "totalIndent", label: "Jumlah Inden", options: { sort: false } },
  {
    name: "compositionPercentage",
    label: "%komposisi",
    options: { sort: false },
  },
];

export const configIndentReportByCabang = [];

const configYearToDate = [
  { name: 1, label: "JAN", options: { sort: false } },
  { name: 2, label: "FEB", options: { sort: false } },
  { name: 3, label: "MAR", options: { sort: false } },
  { name: 4, label: "APR", options: { sort: false } },
  { name: 5, label: "MAY", options: { sort: false } },
  { name: 6, label: "JUN", options: { sort: false } },
  { name: 7, label: "JUL", options: { sort: false } },
  { name: 8, label: "AUG", options: { sort: false } },
  { name: 9, label: "SEP", options: { sort: false } },
  { name: 10, label: "OCT", options: { sort: false } },
  { name: 11, label: "NOV", options: { sort: false } },
  { name: 12, label: "DEC", options: { sort: false } },
  {
    name: "yearToDate",
    label: "Year To Date (Tahun)",
    options: { sort: false },
  },
];

export const indentByCabangConfig = (dataCabang) => [
  ...configHeaderVariant,
  ...dataCabang.map((item) => ({
    name: item.namaDealer,
    label: item.namaDealer,
    options: {
      sort: false,
      customBodyRender: (val) => {
        return (val || "0")
      },
      setCellProps: () => ({
        style: { textAlign: "center" },
      }),
    },
  })),
  { name: "totalDataVariant", label: "Total", options: { sort: false } },
];